import { hasPermission } from '@/shared/utils/permissions';
import { useAuthStore } from '@/store/useAuthStore';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
    page?: string;
}

const ProtectedRoute = ({ page }: Props) => {
    const sessionId = Cookies.get('sessionId');
    const syncAuth = useAuthStore((s) => s.syncAuth);
    const userRole = useAuthStore((s) => s.userRole);
    const user = useAuthStore((s) => s.user);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (sessionId) {
            syncAuth();
        }
        setChecked(true);
    }, [sessionId]);

    if (!sessionId) {
        window.location.href = 'https://itqan.ntelgnt.com';
        return null;
    }

    if (!checked) {
        return null;
    }

    if (page && (!user || !userRole || !hasPermission(userRole, page))) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;